import { styled, Box } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const ToggleWrapper = styled(Box)<{ isMobile?: boolean; minWidth?: string }>`
  padding: 6px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 200px;
  transition: ${animationTransition('background-color', 'box-shadow', 'color')};
  color: ${props => props.theme.colors.mono10};
  text-decoration: none;
  min-width: ${({ minWidth, isMobile }) => (minWidth && !isMobile ? minWidth : isMobile ? '152px' : 'initial')};
  flex: 1;
  cursor: pointer;

  &.active {
    color: ${props => props.theme.colors.mono14};
  }
`;
